import React from 'react';
interface Testimonial {
  quote: string;
  author: string;
}
interface TestimonialBlockProps {
  testimonials: Testimonial[];
}
export function TestimonialBlock({
  testimonials
}: TestimonialBlockProps) {
  return <div className="bg-teal py-9 px-8 my-11 rounded-[3px] max-[600px]:py-7 max-[600px]:px-[22px]" data-id="element-38">
      {testimonials.map((testimonial, index) => <p key={index} className={`text-white font-lora italic text-[clamp(17px,2.5vw,20px)] leading-[1.6] ${index !== testimonials.length - 1 ? 'mb-5 pb-5 border-b border-white/20' : 'mb-0 pb-0 border-none'}`} data-id="element-39">
          "{testimonial.quote}"
          <span className="font-inter text-[12px] tracking-[0.08em] text-white/65 mt-2.5 block not-italic font-medium" data-id="element-40">
            {testimonial.author}
          </span>
        </p>)}
    </div>;
}